var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.75V4.75H6.75V11.75H5.75Z",
    fill: "#4F5F72",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.75V4.75H9.25V11.75H8.25Z",
    fill: "#4F5F72",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0H9.5V2H13V3.5H12V13C12 13.5523 11.5523 14 11 14H4C3.44772 14 3 13.5523 3 13V3.5H2V2H5.5V0ZM6.5 2H8.5V1H6.5V2ZM4.4 3.5V12.6H10.6V3.5H4.4Z",
    fill: "#4F5F72",
    fillOpacity: 0.56
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/delete_grey.e90087e5.svg";
export { ForwardRef as ReactComponent };